import { HttpInterceptorFn } from '@angular/common/http';
import { microServiceUrl } from '@core/helpers';
import { api_key_tap_web, micro_origin } from '@envs/environment';

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
  let headers = req.headers.append('x-api-key', api_key_tap_web);

  if (req.url.includes(microServiceUrl)) {
    headers = headers.append('origen', micro_origin);
  }

  const clonedRequest = req.clone({ headers });

  return next(clonedRequest);
};
